module.exports = __webpack_public_path__ + "img/f31.ae43299b.png";